<template>
  <div
    ref="verificationSMSModal"
    id="verificationSMSModal"
    class="modal modal-v modal-v--mobile-fullscreen fade show"
    tabindex="-1"
    role="dialog"
    aria-labelledby="verificationSMSModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <mobile-menu
          :title="null"
          :profile="$route.meta.profile"
          :search="false"
          :modal="true"
          :bottom="true"
        ></mobile-menu>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="sms-modal">
          <div>
            <h3 class="sms-modal__header">{{ trans.get('profile:edit.sms_verification_modal.header') }}</h3>
            <h4 class="sms-modal__subheader">{{ trans.get('profile:edit.sms_verification_modal.subheader') }}</h4>
          </div>

          <img
            class="sms-modal__graphic"
            src="/img/viluu/other/sms-verification.svg"
            alt="sms img"
          />

          <form
            method="post"
            @submit.prevent="submitStepOne"
            enctype="multipart/form-data"
          >
            <div
              v-if="step === 1"
              class="modal-body d-flex flex-column align-items-center justify-content-start sms-modal__telephone"
            >
              <p class="telephone-top-info">{{ trans.get('profile:edit.sms_verification_modal.first.top-info') }}</p>
              <div class="telephone-input-group">
                <div class="selectdiv selectdiv--underline ">
                  <select v-model="form.prefix" class="telephone-prefix form-control" name="prefix">
                    <option v-for="(name, prefix) in globals.user.phone_prefixes" :key="prefix" :value="prefix">{{ prefix }}</option>
                  </select>
                </div>
                <input
                  v-model="form.phone"
                  type="text"
                  id="phone"
                  name="phone"
                  required
                  min="1"
                  class="input-text input-text__underline telephone-input"
                />

                <button
                  type="submit"
                  :disabled="loading"
                  class="button button__fill mx-auto mt-3 mb-3 telephone-send-button"
                >
                  OK
                </button>
              </div>

              <div v-if="responseErrors.length" class="form-group">
                <span
                  v-for="responseError in responseErrors"
                  class="invalid-feedback d-block"
                  role="alert"
                ><strong>{{ responseError }}</strong></span>
              </div>
              <p class="telephone-bottom-info">
                {{ trans.get('profile:edit.sms_verification_modal.first.bottom-info') }}
              </p>

              <div class="sms-modal__footer">
                {{ trans.get('profile:edit.sms_verification_modal.footer') }}
              </div>
            </div>
          </form>
          <form
            method="post"
            @submit.prevent="submitStepTwo"
            enctype="multipart/form-data"
          >
            <div
              v-if="step === 2"
              class="modal-body d-flex flex-column align-items-center justify-content-start sms-modal__telephone"
            >
              <p class="telephone-top-info">{{ trans.get('profile:edit.sms_verification_modal.second.top-info') }}</p>

              <div class="sms-modal__telephone">
                <div class="telephone-input-group">
                  <input
                    v-model="form.code"
                    type="text"
                    id="code"
                    name="code"
                    class="input-text input-text__underline telephone-input"
                  />
                  <button
                    type="submit"
                    :disabled="loading"
                    class="button button__fill mx-auto mt-3 mb-3 telephone-send-button"
                  >
                    OK
                  </button>
                </div>
              </div>

              <div v-if="responseErrors.length" class="form-group">
                <span
                  v-for="responseError in responseErrors"
                  class="invalid-feedback d-block"
                  role="alert"
                ><strong>{{ responseError }}</strong></span>
              </div>
              <p class="telephone-bottom-info">{{ trans.get('profile:edit.sms_verification_modal.second.bottom-info') }}</p>

              <div>
                <button
                  type="button"
                  class="button button__link mx-auto mb-3 telephone-link-info"
                  @click="submitResend"
                >
                  {{ trans.get('profile:edit.sms_verification_modal.second.resend-link') }}
                </button>
                <button
                  type="button"
                  class="button button__link mx-auto mb-3 telephone-link-info"
                  @click="step = 1"
                >
                  {{ trans.get('profile:edit.sms_verification_modal.second.back-link') }}
                </button>
              </div>
              <div class="sms-modal__footer">
                {{ trans.get('profile:edit.sms_verification_modal.footer') }}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerificationSMSStatusModal',
  props: {},
  data() {
    const defaultPrefix = Object.keys(this.globals.user.phone_prefixes)[0] ?? null;

    return {
      show: false,
      step: 1,
      form: {
        prefix: defaultPrefix,
        phone: null,
        code: null,
      },
      loading: false,
      responseErrors: [],
    };
  },
  computed: {},
  watch: {
    show(val) {
      if (val) {
        $(this.$refs.verificationSMSModal).modal('show');
      } else {
        $(this.$refs.verificationSMSModal).modal('hide');
      }
    },
  },
  methods: {
    submitStepOne() {
      this.responseErrors = [];
      this.loading = true;

      return axios
        .post(zRoute('ajax.user.verification_sms.create'), this.getForm())
        .then(() => {
          this.loading = false;
          this.step = 2;
          this.$store.dispatch('user/load');
        })
        .catch((error) => {
          this.loading = false;

          if (error.response.status === 422) {
            this.setResponseErrors(error.response.data.errors);
          }
          if (error.response.status === 429) {
            this.responseErrors = [error.response.data.message];
          }
          return Promise.reject(error);
        });
    },
    submitStepTwo() {
      this.responseErrors = [];

      this.loading = true;

      return axios
        .post(zRoute('ajax.user.verification_sms.update'), this.getForm())
        .then(() => {
          this.show = false;
          this.loading = false;
          this.$store.dispatch('user/load');
        })
        .catch((error) => {
          this.loading = false;

          if (error.response.status === 422) {
            this.setResponseErrors(error.response.data.errors);
          }
          if (error.response.status === 429) {
            this.responseErrors = [error.response.data.message];
          }
        });
    },
    submitResend() {
      this.submitStepOne()
        .then((v) => {
          this.$notify({
            group: 'custom-template',
            type: 'info',
            title: this.trans.get('profile:edit.sms_verification_modal.second.resend_message'),
            duration: 5000,
            data: {},
          });
        });
    },
    getForm() {
      return {
        phone: this.form.prefix + '' + this.form.phone,
        code: this.form.code,
      };
    },
    setResponseErrors(errors) {
      const values = [];
      for (const [key, err] of Object.entries(errors)) {
        err.forEach((value) => values.push(value));
      }
      this.responseErrors = values;
    },
    load() {
    },
  },
  mounted() {
    let vm = this;
    $(this.$refs.verificationSMSModal).on('hidden.bs.modal', function () {
      vm.show = false;
    });

    this.$eventHub.$on('VerificationSMSStatusOpen', () => {
      vm.show = true;
    });
  },
};
</script>

<style scoped></style>
